import { useState } from 'react';

import IconChevronDown from '@/assets/svg/icon-chevron-down.svg?react';
import IconClose from '@/assets/svg/icon-close.svg?react';
import IconSearchParams from '@/assets/svg/icon-search-params.svg?react';
import IconSearch from '@/assets/svg/icon-search.svg?react';

import { useIsMobile } from '@/hooks/use-mobile';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { SEARCH_PARAMS_LIST } from '@/constants/search-params';

interface UserSearchProps {
  onSearch: (params: { field: string | null; value: string }) => void;
}

export function UserSearch({ onSearch }: UserSearchProps) {
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const isMobile = useIsMobile();

  const handleSearch = () => {
    onSearch({ field: selectedItem, value: searchValue });
  };

  const handleSelectItem = (item: string) => {
    setSelectedItem(item);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    onSearch({ field: selectedItem, value: '' });
  };

  const renderSearchDropdownLabel = () => {
    return isMobile ? (
      <IconSearchParams className="h-[34px] w-[34px]" />
    ) : (
      'Параметри пошуку'
    );
  };

  return (
    <div className="relative flex h-[56px] items-center rounded-md bg-white shadow-sm sm:h-auto sm:p-2.5 sm:pr-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="relative z-10 flex items-center whitespace-nowrap rounded-md py-4 pl-2.5 text-base font-normal text-primary hover:cursor-pointer hover:bg-blue-200 sm:min-w-[200px] sm:py-3">
            {selectedItem || renderSearchDropdownLabel()}
            <IconChevronDown className="ml-1 mr-2 h-3.5 w-3.5 fill-transparent stroke-primary sm:mr-0" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="mt-4 p-1 text-lg sm:w-56">
          {SEARCH_PARAMS_LIST.map((param) => (
            <DropdownMenuItem
              key={param}
              onClick={() => handleSelectItem(param)}
              className="px-4 py-3.5"
            >
              <span className="text-base text-primary">{param}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <input
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder="Оберіть параметрі пошуку"
        className="relative mr-1 h-12 flex-1 rounded-none border-0 border-l border-neutral-200 bg-transparent !pr-8 pl-4 text-base outline-none focus-visible:ring-0 sm:h-12 md:text-sm"
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSearch();
        }}
      />
      {searchValue && (
        <Button
          variant="link"
          size="icon"
          onClick={handleClearSearch}
          className="absolute right-[52px] top-1/2 flex -translate-y-1/2 items-center justify-center bg-transparent sm:right-[130px] [&:hover_svg]:fill-destructive"
        >
          <IconClose className="h-3.5 w-3.5 fill-gray-500" />
        </Button>
      )}
      <Button
        className="h-full w-[48px] rounded-l-none text-white sm:h-[50px] sm:w-[110px] sm:rounded-l-md"
        onClick={handleSearch}
      >
        {!isMobile ? 'Шукати' : <IconSearch className="h-[28px] fill-white" />}
      </Button>
    </div>
  );
}
